<template>
    <rd-container size="large">
        <rd-header :title="$t('index.title', { totalCount : getPzzUserPermissionsManagementTotalCount })">
            <dx-button :use-submit-behavior="false"
                       type="default"
                       :text="$t('buttons.change')"
                       @click="showChangePopup"
                       :disabled="!selectedRowKeys.length">
            </dx-button>
        </rd-header>
        <div class="row">
            <rd-column :size="$columns.TwelveOnLg">
                <!-- Grid -->
                <dx-data-grid :data-source="getPzzUserPermissionsManagementList"
                              :remote-operations="true"
                              :allow-column-resizing="true"
                              :column-auto-width="false"
                              :control-column-resizing="false"
                              :repaint-changes-only="true"
                              :allow-column-reordering="true"
                              :row-alternation-enabled="true"
                              :hover-state-enabled="true"
                              :selected-row-keys="selectedRowKeys"
                              @selection-changed="onSelectionChanged"
                              class="main-datagrid"
                              ref="gridData">
                    <dx-filter-row :visible="true"
                                   apply-filter="auto"
                                   :show-operation-chooser="false" />
                    <dx-column data-field="UserName"
                               :caption="$t('index.captions.userName')"
                               data-type="string" />
                    <dx-column data-field="Level"
                               :caption="$t('index.captions.level')"
                               data-type="number" />
                    <dx-column data-field="AcceptFrom"
                               :caption="$t('index.captions.acceptFrom')"
                               data-type="number" />
                    <dx-column data-field="VisibleFrom"
                               :caption="$t('index.captions.visibleFrom')"
                               data-type="number" />
                    <dx-column data-field="ConfirmationTemplateName"
                               :caption="$t('index.captions.confirmationTemplateName')"
                               data-type="string" />
                    <dx-column data-field="ProjectName"
                               :caption="$t('index.captions.projectName')"
                               data-type="string" />
<!--                    <dx-column data-field="Id"
                               :allow-filtering="false"
                               :allow-reordering="false"
                               :allow-resizing="false"
                               alignment="center"
                               :width="175"
                               :caption="$t('index.captions.actions')"
                               cell-template="cellTemplate" />-->
                    <DxSelection select-all-mode="allPages"
                                 show-check-boxes-mode="onClick"
                                 mode="multiple" />
                    <dx-pager :allowed-page-sizes="pageSizes"
                              :show-page-size-selector="true" />
                    <dx-paging :page-size="30" />
                </dx-data-grid>
                <!-- Change -->

                <rd-popup :visibility="changePopupOptions.popupVisible" :title="$t('change.title')">
                    <changeForm @closeChange="onChangePopupClose" @closeChangeSave="onChangePopupCloseSave" ></changeForm>
                </rd-popup>

            </rd-column>
        </div>
    </rd-container>
</template>
<script>
    // @ is an alias to /src
    import {
        DxDataGrid,
        DxColumn,
        DxFilterRow,
        DxPager,
        DxPaging,
        DxSelection
    } from 'devextreme-vue/data-grid';
    import DxButton from 'devextreme-vue/button';

    import { mapFields } from 'vuex-map-fields';
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    import commonMessages from '../../locales';
    import localMessages from '../locales';
    import changeForm from './Change';

    const name = "administrationStores/dictionariesStores/pzzUserPermissionsManagementStores/indexStore";
    const change = "administrationStores/dictionariesStores/pzzUserPermissionsManagementStores/changeStore";

    export default {
        name: 'appPzzUserPermissionsManagementList',
        data() {
            return {
                cancelBtnOption: {
                    type: "normal",
                    text: this.$t('buttons.cancel'),
                },
                deleteBtnOption: {
                    type: "danger",
                    text: this.$t('buttons.delete'),
                },
                changeBtnOptions: {
                    type: "default",
                    text: this.$t('buttons.change')
                },
                changePopupOptions: {
                    popupVisible: false,
                },
                pageSizes: [30, 50, 100],
                selectedRowKeys: [],
            }
        },
        computed: {
            ...mapGetters(name, ['getPzzUserPermissionsManagementList', 'getPzzUserPermissionsManagementTotalCount']),
            ...mapFields(name, [
            ])
        },
        methods: {
            ...mapActions(name, ['setPzzUserPermissionsManagementList', 'setLoaded', 'setPzzUserPermissionsManagementTotalCount', 'setToken']),
            ...mapMutations(change,['setRecords']),
            showChangePopup() {
                this.setRecords(this.selectedRowKeys);
                this.changePopupOptions.popupVisible = true;
            },
            onChangePopupClose() {
                this.changePopupOptions.popupVisible = false;
            },
            onChangePopupCloseSave() {
                this.changePopupOptions.popupVisible = false;
                this.clearSelection();
            },
            onSelectionChanged({selectedRowKeys}) {
                this.selectedRowKeys = selectedRowKeys;
            },
            clearSelection() {
                const dataGrid = this.$refs["gridData"].instance;
                dataGrid.clearSelection();
            }
        },
        mounted() {
            var gridInstance = this.$refs.gridData.instance;
            var setPzzUserPermissionsManagementTotalCount = this.setPzzUserPermissionsManagementTotalCount;
            this.setLoaded(() => {
                this.totalCount = setPzzUserPermissionsManagementTotalCount(gridInstance.totalCount());
            });
            this.setPzzUserPermissionsManagementList();
            this.setToken();
        },
        components: {
            DxDataGrid,
            DxColumn,
            DxFilterRow,
            DxPager,
            DxPaging,
            DxButton,
            DxSelection,
            changeForm
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>